import makeTable from "./makeTable";

const objectGroup = makeTable({
	allIds: [
		"checkbox",
		"active",
		"name",
		"company",
		"branch",
		"createdAt",
		"properties",
	],
	i18tPath: (id) => `tableColumns.objectGroups.${id}`,
});

export default objectGroup;
